export const COLORS = {
  // ── Canonical June 2026 design system — prefer these in new/refreshed code ──
  // Purple accent (#4136C1, homepage PURPLE.dark) on a cool blue-grey neutral
  // ramp (the N-scale). Retires the legacy blue (#387DFF), flat indigo
  // (#4A3AFF) and blue-violet (#4849FE) accents.
  primary: '#4136C1', // Create / primary action
  primaryHover: '#342BA3', // homepage PURPLE.extraDark — hover
  primaryTint: '#E4E3F9', // Light Violet Accent — colored-active fill
  textPrimary: '#363F5A', // N400 — body copy, headings
  textSecondary: '#545F7E', // N300 — labels, supporting text
  placeholder: '#7683A8', // N200 — placeholder, disabled, tertiary icons
  border: '#C1C9E0', // N100 — default component border (dropdowns, inputs, boxes)
  borderLayout: '#DEE3F0', // lighter divider for layout frames (panel footers/edges)
  borderHover: '#7683A8', // N200 — darker border on hover
  fill: '#EAEBEF', // G-3 — card fill, input bg, hover
  fillStrong: '#DDE3F0', // N50 — stronger fill / subtle dividers
  fillSubtle: '#F7F7F7', // G-2 — type chips, category badges
  canvas: '#FBFBFB', // G-1 — main surface / page canvas
  gutter: '#F6F7FB', // app background behind the floating shell panels
  surface: '#FFFFFF',
  toggleOff: '#DDE3F0', // N50 — toggle off track
  danger: '#DE1111', // Error / Alert
  warning: '#FF8008', // Warning / Low-cost
  premiumGold: '#F4C430',
  magenta: '#FF007B', // Button Pink — credits/unlimited gradient start
  magentaMid: '#FF1CBC', // border-gradient middle stop
  magentaLight: '#FF3AFF', // Button Pink Light — gradient end
  magentaTint: '#FBEEF5', // Light Pink Accent — credits button background

  // ── Legacy aliases, remapped onto the June 2026 palette ──
  // Kept so the many styled files referencing old key names adopt the new look
  // without edits. Migrate to canonical names opportunistically.
  white: '#FFFFFF',
  primaryLight: '#EAEBEF', // selection / hover fill → grey pill
  primarySemiLight: '#EAEBEF',
  primaryExtraLight: '#DDE3F0', // upload-tile / chip bg
  primaryDark: '#4136C1', // accent
  primaryExtraDark: '#4136C1',
  secondaryLight: '#DEE3F0', // NOT a border — default Icon color / skeleton shimmer / slider rail
  secondaryExtraDark: '#363F5A', // N400 — dark text
  secondary: '#545F7E', // N300 — secondary text
  secondarySemiDark: '#363F5A', // N400 — labels / dark text
  secondaryDark: '#363F5A', // N400
  secondarySemiLight: '#7683A8', // N200 — placeholder
  borderColor: '#C1C9E0', // N100 — component borders / dividers
  accentRed: '#DE1111', // Error / Alert
  warningColor: '#FF8008', // Warning / Low-cost
  secondaryUltraLight: '#EAEBEF',
  goldDark: '#F4C430', // premium
  lightGreen: '#90EE90',
  purple: '#4136C1' // purple accent (unlimited banner text, purple buttons)
}

export type TColorKey = keyof typeof COLORS

export const BOX_SHADOW_COLOR = 'rgba(20, 20, 43, 0.1)'
export const SUCCESS_GREEN_COLOR = '#00C785' // Success / New
export const BRIGHT_GREEN_COLOR = '#81C700'
